import http from "../../http";
import { wrapErrorHandler } from "../../utils/wrap_error_handler";
import TrainingCourseInterface from "./training_course_interface";
import { TrainingCourseRequest } from "../../../../domain/entities/courseEvent/training_course";
import { Instructor } from "../../../../domain/entities/entities";

class TrainingCourseRepository implements TrainingCourseInterface {
  async get(id: number): Promise<TrainingCourseRequest> {
    return wrapErrorHandler<TrainingCourseRequest>(async () => {
      const response = await http.get(`/api/decola/graduation/${id}`);
      return response.data;
    });
  }

  async getInstructors(id: number): Promise<Instructor[]> {
    return wrapErrorHandler<Instructor[]>(async () => {
      const response = await http.get(
        `/api/decola/graduation/${id}/instructors`
      );
      return response.data;
    });
  }

  async enroll(id: number): Promise<void> {
    return wrapErrorHandler<void>(async () => {
      return await http.post(`/api/decola/graduation/${id}/enroll`);
    });
  }

  async unenroll(id: number): Promise<void> {
    return wrapErrorHandler<void>(async () => {
      return await http.delete(`/api/decola/graduation/${id}/unenroll`);
    });
  }

  async confirmCheckinQrCode(token: string, id: number): Promise<void> {
    return wrapErrorHandler<void>(async () => {
      const response = await http.post(
        `/api/decola/graduation/check-in/qr-code?confirmation=true&id=${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      return response.data;
    });
  }
}

export default new TrainingCourseRepository() as TrainingCourseInterface;
